import React from 'react';
import { Outlet } from 'react-router-dom';

const LivePage = () => {

    return <Outlet/>

}


export default LivePage